import getConfig from 'next/config'
import { useSelector } from 'react-redux'
import { useState, useEffect } from 'react'
import DeleteIcon from '@material-ui/icons/Delete'
import CreateIcon from '@material-ui/icons/Create'

import { UomAPI } from '../../../api'
import GridColumn from './column.json'
import UomModal from './uom.modal.container'
import { GenerateFilterTerm } from '../../../utils'
import { WrapperContent } from '../../../styles/global.styled'
import { Loading } from '../../../components/loading/loading.styled'
import { Card, MasterHeader, MasterGrid, CodeCell } from '../../../components'

import { Colors } from '../../../styles'
import { LoadingContainer, ActionContainer, ActionCell } from './uom.styled'

const Uom = () => {
  const { publicRuntimeConfig } = getConfig()
  const appSize = useSelector((state) => state.appReducer)
  const height = appSize.height - 190 > 455 ? appSize.height - 190 : 455
  const [dataState, setDataState] = useState({
    skip: 0,
    take: 20,
    filter: [],
    sortable: true,
    filterable: true,
    filterString: '[]',
  })
  const [pending, setPending] = useState(false)
  const [modal, setModal] = useState(false)
  const [detail, setDetail] = useState(false)
  const [edited, setEdited] = useState(false)
  const [deleted, setDeleted] = useState(false)
  const [loading, setLoading] = useState(false)
  const [dataUom, setDataUom] = useState([])
  const [dataItem, setDataItem] = useState(null)
  const [totalUom, setTotalUom] = useState(0)
  const [firstLoad, setFirstLoad] = useState(true)
  const uomRole = useSelector((state) =>
    state.usersLoginReducer.roleMapping.find((e) => e.activeName.includes('master-data/uom'))
  )

  const _getData = async (loading, { skip, take, filterString }) => {
    setLoading(loading)
    try {
      setPending(true)
      const { data, dataCount } = await UomAPI.GetAllMasterDataUom(skip, take, filterString)
      setDataUom(data)
      setTotalUom(dataCount)
      setPending(false)
    } catch (error) {
      setPending(false)
      console.log(error)
    }
    setLoading(false)
  }

  const _onDataStateChange = ({ data }) => {
    GenerateFilterTerm(data.filter, GridColumn)
    setDataState({
      ...dataState,
      ...data,
      filter: data.filter,
      filterString: GenerateFilterTerm(data.filter, GridColumn),
    })
  }

  useEffect(() => {
    const delay = setTimeout(() => {
      if(!firstLoad) {
        _getData(false, { ...dataState,
          filterString: GenerateFilterTerm(dataState.filter, GridColumn) })
      }
    }, publicRuntimeConfig.FILTER_TIMEOUT)
    return () => clearTimeout(delay)
  }, [dataState.filter])

  const _onPageChange = (event) => {
    setDataState({
      ...dataState,
      skip: event.page.skip,
      take: event.page.take,
    })

    _getData(false, {
      skip: event.page.skip,
      take: event.page.take,
      filterString: dataState.filterString,
    })
  }

  const _codeCell = ({ dataItem }) => (
    <CodeCell
      id='m-detail-btn'
      onClick={() => {
        setDataItem(dataItem)
        setModal(!modal)
        setDetail(!detail)
      }}
    >
      {dataItem.Uom_Code}
    </CodeCell>
  )

  useEffect(() => {
    _getData(true, dataState)
    setFirstLoad(false)
  }, [])

  useEffect(() => {
    if(!firstLoad) {
      _getData(false, dataState)
    }
  }, [modal, deleted])

  const _header = () => {
    return (
      <MasterHeader
        allowCreate={uomRole.allowCreate}
        title='MASTER DATA UOM'
        buttonTitle='Add New'
        onClick={() => {
          setModal(!modal)
        }}
      />
    )
  }

  const _actionCell = ({ colSpan, dataItem }) => (
    <td>
      <ActionContainer
        id='m_uom_action_btn'
        onClick={() => setDataItem(dataItem)}
        colSpan={colSpan}
      >
        <ActionCell
          hidden={!uomRole.allowEdit}
          id='m-edit-btn'
          onClick={() => {
            setModal(!modal)
            setEdited(!edited)
          }}
        >
          <CreateIcon htmlColor={Colors.green} />
        </ActionCell>
        <ActionCell
          hidden={!uomRole.allowDelete}
          id='m-delete-btn'
          onClick={() => {
            setDeleted(!deleted)
          }}
        >
          <DeleteIcon htmlColor={Colors.black} />
        </ActionCell>
      </ActionContainer>
    </td>
  )

  const _grid = () => {
    return (
      <MasterGrid
        id='m_uom_grid'
        height={height}
        data={dataUom}
        total={totalUom}
        codeCell={_codeCell}
        dataState={dataState}
        gridColumn={
          !uomRole.allowEdit && !uomRole.allowDelete
            ? GridColumn.filter((e) => e.title !== 'Action')
            : GridColumn
        }
        actionCell={_actionCell}
        pageSizes={[20, 50, 100]}
        onPageChange={(e) => _onPageChange(e)}
        onDataStateChange={(e) => _onDataStateChange(e)}
        pending={pending}
      />
    )
  }

  const _clearModal = () => {
    setModal(false)
    setDetail(false)
    setEdited(false)
    setDeleted(false)
    setDataItem(null)
  }

  return (
    <WrapperContent>
      <Card>
        {_header()}
        {loading ? (
          <LoadingContainer height={height}>
            <Loading />
          </LoadingContainer>
        ) : (
          _grid()
        )}
        <UomModal
          id='m_uom_mdl'
          modal={modal}
          edit={edited}
          detail={detail}
          data={dataItem}
          delete={deleted}
          setDeleted={setDeleted}
          setModal={() => _clearModal()}
        />
      </Card>
    </WrapperContent>
  )
}

export default Uom
